/// <amd-module name="Artifacts/Connect/tools/maven/Protocol" />

import { PackagingService } from "Artifacts/Connect/services/PackagingService";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { IProtocol } from "Artifacts/Connect/types/IProtocol";
import { replaceRouteValues } from "VSS/Platform/Util/Url";

export class MavenProtocol implements IProtocol {
  readonly name = "Maven";
  readonly area = "maven";

  public getFeedUrl(packagingService: PackagingService, combinedFeedView: ICombinedFeedView) {
    // TODO: Move route resolution to endpoints within this object
    const path = replaceRouteValues("_packaging/{feed}/{area}/{resource}/{*path}", {
      feed: combinedFeedView.name,
      area: this.area,
      resource: "v1",
    });

    return packagingService.getUrl(combinedFeedView.project, path);
  }
}
